import React from "react";

export default function MenuNew() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4676_36819)">
        <rect
          x="4.40234"
          y="3.8291"
          width="16.5198"
          height="2.5"
          rx="1.25"
          fill="white"
        />
        <rect
          x="4.40234"
          y="11.1719"
          width="16.5198"
          height="2.5"
          rx="1.25"
          fill="white"
        />
        <rect
          x="4.40234"
          y="18.5137"
          width="16.5198"
          height="2.5"
          rx="1.25"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4676_36819">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.75 0.441406)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
